var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportCounterBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 50,
    viewBox: "0 0 80 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4302 0.997788L42.6445 44.712L42.2893 45.1576C41.4684 46.4049 41.6564 48.0818 42.8127 49.1248C44.1136 50.2982 46.1474 50.2251 47.3553 48.9614L89.141 5.24713L89.4962 4.80161C90.3171 3.55431 90.1291 1.87739 88.9727 0.834351C87.6719 -0.339073 85.6381 -0.2659 84.4302 0.997788ZM61.9406 0.987172L22.0868 42.2898L5.54238 25.4067L5.1065 25.0349C3.87552 24.1622 2.14098 24.2412 0.998075 25.298C-0.287695 26.4871 -0.337784 28.4635 0.886198 29.7125L19.7767 48.9897L20.2308 49.3745C21.5143 50.2715 23.3271 50.1359 24.4499 48.9722L66.6308 5.25795L66.9881 4.81406C67.815 3.57051 67.6351 1.89276 66.4839 0.844454C65.1887 -0.33489 63.1546 -0.270993 61.9406 0.987172Z",
    fill: "#E4E5E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportCounterBackground);
export default __webpack_public_path__ + "static/media/import-counter-background.ce0029205aa75114965d20b3bc534c3c.svg";
export { ForwardRef as ReactComponent };